import moment from "moment";
import { IEvent } from "redux/reducers/models/event";
import { ILeague } from "redux/reducers/models/league";
import { ITournament } from "redux/reducers/models/tournament";

export type TPortalCalendarEventType = "league" | "tournament" | "wedding" | "banquet" | "other";

export type TPortalCalendarEvent = {
  id: number;
  name: string;
  start: string;
  end: string;
  type: TPortalCalendarEventType;
  start_time: string;
  handle?: string;
  display_registration_online?: boolean;
};

export type TPortalEventsByDate = {
  [date: string]: TPortalCalendarEvent[];
};

function hospitalityType(type?: string): TPortalCalendarEventType {
  if (type === "wedding" || type === "banquet" || type === "other") {
    return type;
  }
  return "other";
}

export function mapPortalEventsByDate(params: {
  leagues: ILeague[];
  tournaments: ITournament[];
  hospitalityEvents: IEvent[];
}): TPortalEventsByDate {
  const map: TPortalEventsByDate = {};

  const addEvent = (dateKey: string, event: TPortalCalendarEvent) => {
    if (!map[dateKey]) {
      map[dateKey] = [];
    }
    map[dateKey].push(event);
  };

  params.leagues.forEach(league => {
    if (!league.start_date || !league.week_day) {
      return;
    }

    const start = moment(league.start_date);
    const end = league.end_date ? moment(league.end_date) : start.clone();
    const targetWeekday = moment().day(league.week_day).day();
    const current = start.clone();

    while (current.isSameOrBefore(end, "day")) {
      if (current.day() === targetWeekday) {
        const key = current.format("YYYY-MM-DD");
        addEvent(key, {
          id: league.id,
          name: league.name,
          start: key,
          end: key,
          type: "league",
          start_time: league.start_time,
          handle: league.handle,
          display_registration_online: league.display_registration_online,
        });
      }
      current.add(1, "day");
    }
  });

  params.tournaments.forEach(tournament => {
    if (!tournament.date) {
      return;
    }

    const start = moment(tournament.date);
    const end = tournament.end_date ? moment(tournament.end_date) : start.clone();
    const current = start.clone();

    while (current.isSameOrBefore(end, "day")) {
      const key = current.format("YYYY-MM-DD");
      addEvent(key, {
        id: tournament.id,
        name: tournament.name,
        start: start.format("YYYY-MM-DD"),
        end: end.format("YYYY-MM-DD"),
        type: "tournament",
        start_time: tournament.start_time,
        handle: tournament.handle,
        display_registration_online: tournament.display_registration_online,
      });
      current.add(1, "day");
    }
  });

  params.hospitalityEvents.forEach(event => {
    if (!event.date) {
      return;
    }

    const start = moment(event.date);
    const end = event.end_date ? moment(event.end_date) : start.clone();
    const current = start.clone();

    while (current.isSameOrBefore(end, "day")) {
      const key = current.format("YYYY-MM-DD");
      addEvent(key, {
        id: event.id,
        name: event.name,
        start: start.format("YYYY-MM-DD"),
        end: end.format("YYYY-MM-DD"),
        type: hospitalityType(event.type),
        start_time: event.start_time,
        handle: event.handle,
        display_registration_online: event.display_registration_online,
      });
      current.add(1, "day");
    }
  });

  Object.keys(map).forEach(key => {
    map[key].sort((a, b) => a.name.localeCompare(b.name));
  });

  return map;
}
